/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OnboardingBusinessInfoDTO = {
    businessSector?: string;
    email?: string;
    estimatedTurnover?: OnboardingBusinessInfoDTO.estimatedTurnover;
    staffStrength?: OnboardingBusinessInfoDTO.staffStrength;
    userExternalId?: string;
};

export namespace OnboardingBusinessInfoDTO {

    export enum estimatedTurnover {
        LESS_THAN_5_MILLION = 'LESS_THAN_5_MILLION',
        TURN_OVER_5M_TO_20M = 'TURN_OVER_5M_TO_20M',
        TURN_OVER_20M_TO_50M = 'TURN_OVER_20M_TO_50M',
        TURN_OVER_50M_TO_100M = 'TURN_OVER_50M_TO_100M',
        TURN_OVER_100M_TO_250M = 'TURN_OVER_100M_TO_250M',
        TURN_OVER_250M_TO_500M = 'TURN_OVER_250M_TO_500M',
        TURN_OVER_500M_TO_1B = 'TURN_OVER_500M_TO_1B',
        MORE_THAN_1_BILLION = 'MORE_THAN_1_BILLION',
    }

    export enum staffStrength {
        JUST_ME_1 = 'JUST_ME_1',
        STAFF_2_5 = 'STAFF_2_5',
        STAFF_6_10 = 'STAFF_6_10',
        STAFF_11_20 = 'STAFF_11_20',
        STAFF_21_50 = 'STAFF_21_50',
        STAFF_51_100 = 'STAFF_51_100',
        STAFF_101_250 = 'STAFF_101_250',
        STAFF_251_PLUS = 'STAFF_251_PLUS',
    }


}

